/* eslint-disable */
window.platformUIFederationUrl = process.env.REACT_APP_PLATFORM_V2_URL
// the env var changes dont trigger a platform-ui rebuild so this comment is here to force a rebuild: v1
window.athenaOneFederationUrl = process.env.REACT_APP_ATHENA_ONE_FEDERATION_URL
import('./main')
